// --- ✅ Dynamically load Hls.js if not already loaded ---
function loadHlsLibrary(callback) {
  if (window.Hls) {
    callback();
    return;
  }
  const script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
  script.onload = callback;
  document.head.appendChild(script);
}

// --- ✅ Initialize all thumb videos (works for .m3u8 + .mp4) ---
function initVideoPopupThumb(context = document) {
  console.log("🎬 initVideoPopupThumb running in:", context);

  loadHlsLibrary(() => {
    context.querySelectorAll(".thumb-video").forEach(function(videoEl) {
      if (videoEl.dataset.initialized) return; // prevent double init
      videoEl.dataset.initialized = "true";

      const videoSrc = videoEl.getAttribute("data-src");
      if (!videoSrc) return;
      console.log("→ Initializing video:", videoSrc);

      // Handle HLS (.m3u8)
      if (videoSrc.includes(".m3u8")) {
        if (window.Hls && Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoSrc);
          hls.attachMedia(videoEl);

          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            videoEl.muted = true;
            videoEl.play().catch(() => {});
          });

          videoEl.addEventListener("canplay", function() {
            if (videoEl.paused) {
              videoEl.muted = true;
              videoEl.play().catch(() => {});
            }
          });
        } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
          // Safari native HLS
          videoEl.src = videoSrc;
          videoEl.addEventListener("loadedmetadata", function() {
            videoEl.muted = true;
            videoEl.play().catch(() => {});
          });
        } else {
          console.warn("⚠️ HLS not supported on this browser:", videoSrc);
        }
      } 
      // Handle MP4 or other formats
      else {
        videoEl.src = videoSrc;
        videoEl.addEventListener("loadedmetadata", function() {
          videoEl.muted = true;
          videoEl.play().catch(() => {});
        });
      }
    });
  });
}

// --- ✅ Run once on normal page load ---
document.addEventListener("DOMContentLoaded", function() {
  initVideoPopupThumb();
});

// --- ✅ Observe for dynamically added videos (Quick View etc.) ---
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches(".thumb-video")) {
          initVideoPopupThumb(node.parentElement || document);
        } else if (node.querySelector && node.querySelector(".thumb-video")) {
          initVideoPopupThumb(node);
        }
      }
    });
  });
});

// Start observing for DOM changes
observer.observe(document.body, { childList: true, subtree: true });
